export default "__VITE_ASSET__CRilFaZG__"